import { all } from "redux-saga/effects";
import { propertyUpdateWatcher, propertyViewWatcher } from "../../property-saga/propertyViewSaga";

export default function* propertyDetailsRootSaga() {
  yield all([
    propertyViewWatcher(),
    propertyUpdateWatcher(),
  ]);
}
